// Module
var code = "<div class=\"master-container\"><navigation ng-hide=\"$root.noNavigation\"></navigation><div id=\"main\"><demo-banner></demo-banner><div ui-view></div></div></div><snackbar></snackbar>";
// Exports
module.exports = code;